import {
	CLOSE_GLOBAL_SNACKBAR,
	OPEN_GLOBAL_SNACKBAR,
	MULTIPLE_FILE_UPLOAD_SUCCESS,
	MULTIPLE_FILE_UPLOAD_FAILURE,
	BULK_FILE_UPLOAD_FAILURE,
	DELETE_SUCCESS,
	RESTORE_FROM_TRASH_SUCCESS,
	RESTORE_FROM_ARCHIVE_SUCCESS,
	PASTE_SUCCESS,
	PASTE_FAILURE,
	UPLOAD_NEW_VERSION_SUCCESS,
	SET_DOCUMENT_LOCK_SUCCESS,
	CLOSE_MATTER_SUCCESS,
	REOPEN_MATTER_SUCCESS,
	REINDEX_SUCCESS,
	REINDEX_FAILURE,
	BULK_DOWNLOAD_FAILURE,
	BULK_DOWNLOAD_SUCCESS,
	FOLDER_NAME_CONFLICT,
	BULK_EXTERNAL_SEND_FAILURE,
	BULK_EXTERNAL_SEND_SUCCESS,
	CONVERT_TO_PDF_SUCCESS,
	CONVERT_TO_PDF_FAILURE,
	UPLOAD_NEW_VERSION_FAILURE,
	REQUEST_OCR_SUCCESS,
	REQUEST_OCR_FAILURE,
	UPDATE_OCR_SNACKBAR_MESSAGE,
	AUDIT_SEARCH_SUCCESS,
	AUDIT_SEARCH_FAILURE,
	INDEX_MISSING_SEARCH_ITEMS_SUCCESS,
	INDEX_MISSING_SEARCH_ITEMS_FAILURE,
	OPEN_PERSISTENT_ERROR_SNACKBAR,
	OPEN_PERSISTENT_SNACKBAR,
	CREATE_NOTE_SUCCESS,
	ARCHIVE_SUCCESS,
} from "../actions/types";
import React from "react";

import { shortDateFormat } from "../utilities/utilities";

const initialState = {
	open: false,
	message: "",
	variant: "",
	autoHideDuration: 6000,
	loadingSpinnerVisible: false,
	allowClose: true,
	disableWindowBlurListener: false,
};

const snackbarStateHolder = {
	// [snackbarKey] = { $stateForSnackbar }
};

const allowedVariants = ["error", "warning", "info", "success"];
// when using undefined as a key in an object, it will be converted to "undefined" string
const allowedSnackbarKeys = [
	undefined,
	"undefined",
	"documentCompare",
	"emailUploadParseWarning", // if an email cannot be parsed during upload
	"mfa-setup-success",
	"version-mismatch",
];
export default function (state = snackbarStateHolder, action) {
	const SNACKBAR_KEY = action?.payload?.snackbarKey;
	if (!allowedSnackbarKeys.includes(SNACKBAR_KEY)) {
		console.error("Invalid snackbarKey: ", SNACKBAR_KEY);
		return state;
	}
	switch (action.type) {
		case MULTIPLE_FILE_UPLOAD_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: `Successfully uploaded ${action.payload.num} ${
						action.payload.objectType || "File"
					}${action.payload.num > 1 ? "s" : ""}`,
					variant: "success",
				},
			};
		case MULTIPLE_FILE_UPLOAD_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: `There was a problem with the upload.  The ${
						action.payload ? action.payload.num : ""
					} file(s) were not successfully uploaded`,
					variant: "error",
				},
			};
		case BULK_FILE_UPLOAD_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message:
						action.payload && action.payload.message
							? action.payload.message
							: `There was a problem with the upload.  The ${
									action.payload ? action.payload.num : ""
								} file(s) were not successfully uploaded`,
					variant: "error",
					autoHideDuration:
						action.payload &&
						action.payload.autoHideDuration !== undefined
							? action.payload.autoHideDuration
							: initialState.autoHideDuration,
				},
			};
		case CONVERT_TO_PDF_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.message,
					variant: "success",
					loadingSpinnerVisible: false,
					allowClose: true,
					autoHideDuration:
						action.payload &&
						action.payload.autoHideDuration !== undefined
							? action.payload.autoHideDuration
							: initialState.autoHideDuration,
				},
			};
		case REQUEST_OCR_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.message,
					variant: "success",
					loadingSpinnerVisible: false,
					allowClose: true,
					autoHideDuration:
						action.payload &&
						action.payload.autoHideDuration !== undefined
							? action.payload.autoHideDuration
							: initialState.autoHideDuration,
				},
			};
		case REQUEST_OCR_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case DELETE_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: (
						<div>{action.payload.itemType} sent to Trash Bin.</div>
					),
					variant: "success",
				},
			};
		case RESTORE_FROM_TRASH_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: (
						<div>
							{action.payload.itemType} restored from Trash Bin.
						</div>
					),
					variant: "success",
				},
			};
		case ARCHIVE_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					...state[SNACKBAR_KEY],
					open: true,
					message: <div>{action.payload.itemType} Archived.</div>,
					variant: "success",
				},
			};
		case RESTORE_FROM_ARCHIVE_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					...state[SNACKBAR_KEY],
					open: true,
					message: <div>{action.payload.itemType} Unarchived.</div>,
					variant: "success",
				},
			};
		case PASTE_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.destinationUrl ? (
						<div>
							{action.payload.itemType} {action.payload.verb}.
							Click{" "}
							<a
								className="lw-internal-action-link white"
								href={action.payload.destinationUrl}
							>
								here
							</a>{" "}
							to go there.
						</div>
					) : (
						`${action.payload.itemType} ${action.payload.verb}`
					),
					variant: "success",
					autoHideDuration: 6000,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case PASTE_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.destinationUrl ? (
						<div>
							There was a problem with pasting. Click{" "}
							<a
								className="lw-internal-action-link white"
								href={action.payload.destinationUrl}
							>
								here
							</a>{" "}
							to go back and try again.
						</div>
					) : (
						action.payload.message ||
						"There was a problem with pasting"
					),
					variant: "error",
					autoHideDuration: 6000,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case REINDEX_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message:
						"Reindex job created.  Click refresh button to see progress",
					variant: "success",
					autoHideDuration: 6000,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case REINDEX_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: "Reindex job failed",
					variant: "error",
					autoHideDuration: 6000,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case UPLOAD_NEW_VERSION_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: "New Version Uploaded",
					variant: "success",
				},
			};
		case UPLOAD_NEW_VERSION_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: `${
						action && action.payload && action.payload.message
							? action.payload.message
							: "New version could not be uploaded"
					}`,
					variant: "error",
				},
			};
		case SET_DOCUMENT_LOCK_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: `Document Checked ${
						action.payload.lockStatus ? "Out" : "In"
					}`,
					variant: "success",
				},
			};
		case CLOSE_MATTER_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: `Matter closed on ${shortDateFormat(
						action.payload.closedDate
					)}`,
					variant: "success",
				},
			};
		case REOPEN_MATTER_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: "Matter Reopened",
					variant: "success",
				},
			};
		case CLOSE_GLOBAL_SNACKBAR:
			// eslint-disable-next-line no-case-declarations
			const next = { ...state };
			delete next[SNACKBAR_KEY];
			return next;
		case OPEN_GLOBAL_SNACKBAR:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.message,
					variant: allowedVariants.includes(action.payload.variant)
						? action.payload.variant
						: "info",
					autoHideDuration: action.payload.autoHideDuration || 6000,
					loadingSpinnerVisible:
						action.payload.loadingSpinnerVisible || false,
					allowClose: false,
					disableWindowBlurListener:
						action.payload.disableWindowBlurListener || false,
				},
			};
		case "OPEN_LOADING_SNACKBAR":
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					autoHideDuration: null,
					variant: "info",
					message: action.payload.message || "Calculating...",
					loadingSpinnerVisible: true,
					allowClose: false,
				},
			};
		case "UPDATE_SNACKBAR_MESSAGE":
			// merges the previous state because this only ticks the message on
			// the loading snackbar this job's own OPEN_LOADING_SNACKBAR just
			// opened.
			// TODO: bug - a second job sharing this key (most callers omit
			// snackbarKey) will overwrite it, and this tick then overwrites that.
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					...state[SNACKBAR_KEY],
					message: action.payload.message,
				},
			};
		case UPDATE_OCR_SNACKBAR_MESSAGE:
			// merges for the same reason as UPDATE_SNACKBAR_MESSAGE above
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					...state[SNACKBAR_KEY],
					variant: allowedVariants.includes(action.payload.variant)
						? action.payload.variant
						: "info",
					loadingSpinnerVisible: false,
					allowClose: true,
					message: action.payload.message,
				},
			};
		case BULK_DOWNLOAD_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case BULK_DOWNLOAD_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "success",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case BULK_EXTERNAL_SEND_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case BULK_EXTERNAL_SEND_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "success",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
					autoHideDuration: action.payload.sharePassword
						? null
						: 6000,
					sharePassword: action.payload.sharePassword || null,
					shareID: action.payload.shareID || null,
				},
			};
		case FOLDER_NAME_CONFLICT:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message:
						"There is already a " +
						(action.payload.length &&
						action.payload[0].folderLifecycleStatus &&
						action.payload[0].folderLifecycleStatus !== "normal"
							? "deleted "
							: "") +
						"folder with that name",
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case CONVERT_TO_PDF_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case AUDIT_SEARCH_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.message,
					variant: "success",
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case AUDIT_SEARCH_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case INDEX_MISSING_SEARCH_ITEMS_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					message: action.payload.message,
					variant: "success",
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case INDEX_MISSING_SEARCH_ITEMS_FAILURE:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					message: action.payload.message,
					loadingSpinnerVisible: false,
					allowClose: true,
				},
			};
		case OPEN_PERSISTENT_ERROR_SNACKBAR:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "error",
					allowClose: true,
					autoHideDuration: null,
					message:
						action.payload.message || "An unknown error occured",
					loadingSpinnerVisible: false,
				},
			};
		case OPEN_PERSISTENT_SNACKBAR:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: action.payload.variant,
					allowClose: true,
					autoHideDuration: null,
					message: action.payload.message,
					loadingSpinnerVisible: false,
				},
			};
		case "OPEN_PERSISTENT_SNACKBAR_NOT_CLOSEABLE":
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: action.payload.variant,
					allowClose: false,
					autoHideDuration: null,
					message: action.payload.message,
					loadingSpinnerVisible: false,
				},
			};
		case "SHOW_VERSION_MISMATCH":
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "warning",
					allowClose: true,
					autoHideDuration: null,
					message: (
						<div>
							A new version is available. Click{" "}
							<a
								className="lw-internal-action-link black"
								onClick={() => window.location.reload()}
							>
								here
							</a>{" "}
							to refresh.
						</div>
					),
					loadingSpinnerVisible: false,
				},
			};
		case CREATE_NOTE_SUCCESS:
			return {
				...state,
				[SNACKBAR_KEY]: {
					...initialState,
					open: true,
					variant: "success",
					allowClose: true,
					autoHideDuration: 6000,
					message: "Matter Note Created",
					loadingSpinnerVisible: false,
				},
			};

		default:
			return state;
	}
}
